const toLocal = 'convert-to-local';
const toUtc = 'convert-to-utc';

const _getDateObject = (date, convertOption) => {
  if (date instanceof Date) {
    return _convertDate(date, convertOption);
  } else {
    return _convertDate(new Date(date), convertOption);
  }
};

const _convertDate = (dateObject, convertOption) => {
  if (convertOption === toLocal) {
    return toLocalTime(dateObject);
  }

  if (convertOption === toUtc) {
    return toUtcTime(dateObject);
  }

  return dateObject;
};

const toLocalTime = (dateStringOrObject) => {
  const datetime = _getDateObject(dateStringOrObject);
  datetime.setMinutes(datetime.getMinutes() - datetime.getTimezoneOffset());
  return datetime;
};

const toUtcTime = (dateStringOrObject) => {
  const datetime = _getDateObject(dateStringOrObject);
  var utc = Date.UTC(
    datetime.getUTCFullYear(),
    datetime.getUTCMonth(),
    datetime.getUTCDate(),
    datetime.getUTCHours(),
    datetime.getUTCMinutes(),
    datetime.getUTCSeconds()
  );

  const utcDatetime = new Date(utc);
  return utcDatetime;
};

const formatDate = (dateStringOrObject, convertOption) => {
  return _getDateObject(dateStringOrObject, convertOption).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

const formatTime = (dateStringOrObject, convertOption) => {
  return _getDateObject(dateStringOrObject, convertOption).toLocaleDateString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

const formatDateTime = (dateStringOrObject, convertOption) => {
  return _getDateObject(dateStringOrObject, convertOption).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const getLocalCulture = () => {
  return navigator.language || navigator.userLanguage;
};

export const datetimeFormatter = {
  toLocal,
  toUtc,
  toLocalTime,
  toUtcTime,
  formatDate,
  formatTime,
  formatDateTime,
};
